'use strict';
require('../../modules/es.object.get-own-property-descriptor');
var path = require('../../internals/path');

var Object = path.Object;

var getOwnPropertyDescriptor = module.exports = function getOwnPropertyDescriptor(it, key) {
  return Object.getOwnPropertyDescriptor(it, key);
};

if (Object.getOwnPropertyDescriptor.sham) getOwnPropertyDescriptor.sham = true;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/object/get-own-property-descriptor.js
// module id = 581
// module chunks = 13